export default class BBInfo {
    minx: number;
    maxx: number;
    miny: number;
    maxy: number;
    minz: number;
    maxz: number;
    dimension: number;
    centerx: number;
    centery: number;
    centerz: number;
    pointAx: number;
    pointAy: number;
    pointAz: number;
    pointBx: number;
    pointBy: number;
    pointBz: number;

    constructor(minx: number, maxx: number, miny: number, maxy: number, minz: number, maxz: number) {
        this.minx = minx;
        this.maxx = maxx;
        this.miny = miny;
        this.maxy = maxy;
        this.minz = minz;
        this.maxz = maxz;
        this.dimension = Math.max(maxx - minx, maxy - miny, maxz - minz);
        this.centerx = (minx + maxx) / 2;
        this.centery = (miny + maxy) / 2;
        this.centerz = (minz + maxz) / 2;
        this.pointAx = 0;
        this.pointAy = 0;
        this.pointAz = 0;
        this.pointBx = 0;
        this.pointBy = 0;
        this.pointBz = 0;
    }

    set_pointA(x: number, y: number, z: number) {
        this.pointAx = x;
        this.pointAy = y;
        this.pointAz = z;
    }

    set_pointB(x: number, y: number, z: number) {
        this.pointBx = x;
        this.pointBy = y;
        this.pointBz = z;
    }
}
